import { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { fetchProducts } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

export default function Shop() {
  const { t } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchProducts()
      .then(setProducts)
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="shop-page" className="bg-black min-h-screen pt-28 md:pt-32">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 pb-20 md:pb-32">
        <div className="border-b border-white/10 pb-10 mb-14">
          <p className="overline mb-3">{t.hero.launchLabel}</p>
          <h1 className="h-display text-white text-6xl sm:text-7xl md:text-8xl">
            {t.shop.title}
          </h1>
          <p className="mt-6 text-white/60 max-w-xl leading-relaxed">
            {t.shop.subtitle}
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
            {[0, 1, 2].map((i) => (
              <div key={i} className="animate-pulse">
                <div className="aspect-[3/4] bg-zinc-900" />
                <div className="h-4 bg-zinc-900 mt-4 w-2/3" />
              </div>
            ))}
          </div>
        ) : products.length === 0 ? (
          <p data-testid="shop-empty" className="text-white/60 py-20 text-center">
            {t.shop.empty}
          </p>
        ) : (
          <div
            data-testid="shop-product-grid"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14"
          >
            {products.map((p) => (
              <ProductCard key={p.id} product={p} priority />
            ))}
          </div>
        )}

        {/* Scalable note for future growth */}
        <p className="mt-16 text-center text-[11px] uppercase tracking-[0.3em] text-white/30">
          {t.shop.moreSoon}
        </p>
      </div>
    </main>
  );
}
